<template>
	<rr-menu :items="items" :class="$style['social-links-menu']"/>
</template>

<script>
export default {
	name: 'SocialLinks',
	data() {
		return {
			items: [
				{
					brandIconFileName: 'facebook-f.svg',
					href: 'https://www.facebook.com/motiondesignschool/',
					linkWrapOptions: {
						isBlank: true,
					},
				},
				{
					brandIconFileName: 'instagram.svg',
					href: 'https://www.instagram.com/motiondesignschool/',
					linkWrapOptions: {
						isBlank: true,
					},
				},
				{
					brandIconFileName: 'dribbble.svg',
					href: 'http://dribbble.com/motiondesignschool',
					linkWrapOptions: {
						isBlank: true,
					},
				},
				{
					brandIconFileName: 'behance.svg',
					href: 'https://www.behance.net/yaroflasher',
					linkWrapOptions: {
						isBlank: true,
					},
				},
			]
		}
	},
	// props: {
	// 	textType: {
	// 		type: String,
	// 	},
	// },
	mounted() {
	},
	destroyed() {
	},
	methods: {},
	watch: {},
}
</script>

<style module lang="scss">
// menu
ul.social-links-menu {
	> li {
		&:nth-child(n+2) {
			margin-left: 18px;
		}
	}
	// icons
	> li > a {
		display: flex;
		align-items: center;
		justify-content: center;
		@include sizing-responsive-square-screen-x(51);
		border: solid 1px var(--gray);
		border-radius: 50%;
		transition: border-width $transitionDurationFast $transitionTimingFunction;
		// mobile
		@include breakpoint($mobileDesignBreakpoint) {
			@include sizing-responsive-square-screen-x(42px);
		}
		// icons
		svg {
			display: block;
			width: 100%;
			max-width: 40%;
			max-height: 40%;
			path {
				@extend %transition-fill-fast;
				fill: var(--gray);
			}
		}
		// states
		&:hover {
			border-width: 0;
			// icons
			svg {
				path {
					fill: var(--light);
				}
			}
		}
	}
}
</style>
